module.exports = __webpack_public_path__ + "static/media/family_06.cd26d017.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/family/JPEG/family_06.jpg
// module id = 5838
// module chunks = 0